<div class="error-container">
    <p>{{errorMessage}}</p>
</div>